import React from 'react';

type IconProps = React.SVGAttributes<SVGElement> & {
	size: number;
};

const Bullhorn = ({ size, ...props }: IconProps): React.ReactElement => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 32 32"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path d="M27 4C26.762 4 26.55 4.088 26.375 4.225C26.375 4.225 21.575 8 17 8H10C6.687 8 4 10.688 4 14C4 17.312 6.688 20 10 20H10.025C10.263 24.65 12.088 27.425 12.163 27.55C12.351 27.825 12.663 28 13.001 28H17.001C17.551 28 18.001 27.55 18.001 27V20.062C22.251 20.524 26.376 23.787 26.376 23.787C26.551 23.924 26.763 24.012 27.001 24.012C27.551 24.012 28.001 23.562 28.001 23.012V5C28.001 4.45 27.551 4 27.001 4H27ZM16 26H13.575C13.125 25.137 12.2 23.038 12.025 20H16V26V26ZM16 18H10C7.8 18 6 16.2 6 14C6 11.8 7.8 10 10 10H16V18ZM18 9.95C21.2 9.663 24.225 8.05 26 6.913V21.075C24.225 19.938 21.2 18.337 18 18.037V9.949V9.95Z" />
	</svg>
);

export default Bullhorn;
